<template>

  <div :class="['navigation', { 'scrolled': isScrolled || isTreatments }]">
    <div class="container">

      <router-link to="/" class="logo">
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 406.77 448">
          <path fill="#ffd9be" class="st0" d="M203.38,205.42c-40.79,0-73.98-33.19-73.98-73.98s33.19-73.98,73.98-73.98,73.98,33.19,73.98,73.98-33.19,73.98-73.98,73.98ZM203.38,71.91c-32.81,0-59.54,26.69-59.54,59.54s26.69,59.54,59.54,59.54,59.54-26.69,59.54-59.54-26.69-59.54-59.54-59.54ZM26.05,213.92C12.84,145.82,42.35,76.93,83.14,23.34,44.31,59.66,16.56,109.19,9.95,162.4c-5.67,45.23,7.77,91.66,34.63,128.19,25.97,36.08,62.39,64.18,100.95,84.68-53.41-41.27-106.14-92.69-119.48-161.38v.03Z"/>
          <path fill="#ffd9be" class="st0" d="M194.2,416.46c9.05-136.61-108.51-272.23-131.01-296.82,6.26-21.77,16.47-42.58,29.99-61.36-41.65,38.69-59.36,100.88-45.92,156.04,1.31,5.37,2.96,11.9,4.85,17.09,3.47,10.87,8.7,22.32,14.07,32.4,2.48,5.12,5.98,10.28,8.91,15.17,3.51,5.78,9.39,13.69,13.41,19.12,2.41,2.96,8.56,10.39,11.11,13.45,5.19,5.71,10.49,11.35,15.92,16.82,3.78,3.54,11.07,10.32,14.82,13.72,5.98,4.88,14.03,11.66,20.15,16.23,5.37,3.85,13.41,9.6,18.78,13.21-37.7-37.08-73.47-76.04-95.55-124.16-2.75-6.81-5.85-13.52-7.94-20.53l-1.79-5.19c-1.24-4.06-2.37-9.15-3.54-13.24-.86-4.47-1.79-8.94-2.51-13.45-1.58-10.39-2.13-20.77-1.82-31.13,114.5,100.22,138.02,252.62,138.02,252.62h.03ZM380.72,213.92c13.21-68.1-16.3-136.99-57.09-190.58,38.83,36.32,66.59,85.85,73.19,139.05,5.67,45.23-7.77,91.66-34.63,128.19-25.97,36.08-62.39,64.18-100.95,84.68,53.41-41.27,106.14-92.69,119.48-161.38v.03Z"/>
          <path fill="#ffd9be" class="st0" d="M212.57,416.46c-9.05-136.61,108.51-272.23,131.01-296.82-6.26-21.77-16.47-42.58-29.99-61.36,41.65,38.69,59.36,100.88,45.92,156.04-1.31,5.37-2.96,11.9-4.85,17.09-3.47,10.87-8.7,22.32-14.07,32.4-2.48,5.12-5.98,10.28-8.91,15.17-3.51,5.78-9.39,13.69-13.41,19.12-2.41,2.96-8.56,10.39-11.11,13.45-5.19,5.71-10.49,11.35-15.92,16.82-3.78,3.54-11.07,10.32-14.82,13.72-5.98,4.88-14.03,11.66-20.15,16.23-5.37,3.85-13.41,9.6-18.78,13.21,37.7-37.08,73.47-76.04,95.55-124.16,2.75-6.81,5.85-13.52,7.94-20.53l1.79-5.19c1.24-4.06,2.37-9.15,3.54-13.24.86-4.47,1.79-8.94,2.51-13.45,1.58-10.39,2.13-20.77,1.82-31.13-114.5,100.22-138.02,252.62-138.02,252.62h-.03Z"/>
        </svg>
    
        <div class="logo-text">
          Healing 
        </div>

        <div class="logo-text">
          Path
        </div> 
      </router-link>
  
      <button class="menu-toggle" @click="menuOpen = !menuOpen" aria-label="Meny">
        <span :class="{ open: menuOpen }"></span>
        <span :class="{ open: menuOpen }"></span>
        <span :class="{ open: menuOpen }"></span>
      </button>

      <nav :class="{ open: menuOpen }">
        <!-- <router-link to="/">Home</router-link> -->
        <!-- <router-link to="/about">About</router-link> -->
        <router-link to="/" @click="closeMenu">Hjem</router-link>
        <router-link to="/therapy" @click="closeMenu">Om terapien</router-link>
        <router-link to="/treatments" @click="closeMenu">Behandlinger</router-link>
        <router-link to="/booking" @click="closeMenu">Booking</router-link>
        <router-link to="/contact" @click="closeMenu">Kontakt oss</router-link>
      </nav>

    </div>
  </div>
  
</template>

<script>
export default {
  data() {
    return {
      isScrolled: false,
      menuOpen: false,
    };
  },
  computed: {
    isTreatments() {
      return this.$route && this.$route.path === '/treatments';
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  },
  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.handleScroll);
  //   window.removeEventListener('resize', this.handleResize);
  // },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0;
    },
    handleResize() {
      if (window.innerWidth > 900 && this.menuOpen) {
        this.menuOpen = false;
      }
    },
    closeMenu() {
      this.menuOpen = false;
    }
  },
  watch: {
    $route() {
      // Ensure nav background updates on route change
      this.handleScroll();
    }
  }
}
</script>

<style lang="scss">

.navigation {
  display: flex;
  flex-wrap: row;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 1000;
  width: 100%;
  transition: all 0.2s ease-in-out;
  background: rgba(216, 213, 207, 0);
  // background: linear-gradient(300deg,rgba(232, 232, 230, 0) 0%, rgba(216, 213, 207, 0) 50%);

  &.scrolled {
    background: rgba(216, 213, 207, 1);
    // background: linear-gradient(300deg,rgba(232, 232, 230, 1) 0%, rgba(216, 213, 207, 1) 50%);
  }

  .container {
    // max-width: 1200px;
    // margin: 0 auto;
    // padding: 10px 20px;
    display: flex;
    flex-wrap: row;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    width: 220px;
    height: 100px;

    display: flex;
    flex-wrap: row;
    align-items: center;
    
    svg {
      width: 40px;
      height: 50px;
      margin-right: 7px;

      path {
        fill: black;
      }
      
    }

    .logo-text {
      font-size: 1.5rem;
      font-weight: bold;
      font-family: $merriweather;
      font-weight: 300;
      text-wrap: nowrap;
      margin-left: 5px;

      color: black;

      &:first-letter {
        font-size: 1.5rem;
        font-weight: 500;
        // color: $text-dark;
      }
    }
  }

  .menu-toggle {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 1100;
    margin-left: 10px;

    span {
      display: block;
      width: 28px;
      height: 3px;
      margin: 4px 0;
      background: black;
      border-radius: 2px;
      transition: 0.3s;
    }
    span.open:nth-child(1) {
      transform: translateY(7px) rotate(45deg);
    }
    span.open:nth-child(2) {
      opacity: 0;
    }
    span.open:nth-child(3) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }

  nav {
    padding: 30px;
    display: flex;
    flex-wrap: row;
    align-items: center;

    a {
      font-family: $figtree;
      font-weight: 400;
      font-size: 1.1rem;
      color: $text-light;
      margin-right: 20px;
      color: black;

      &.router-link-exact-active {
        // color: $text-light;
        text-decoration: underline;
        text-decoration-thickness: 0.1em;
        text-decoration-thickness: 2px;
        text-decoration-line:overline;
      }

    }

    @media (max-width: 900px) {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: rgba(216, 213, 207, 1);
      flex-direction: column;
      align-items: flex-start;
      padding: 20px 30px 20px 30px;
      display: none;
      box-shadow: 0 4px 16px rgba(0,0,0,0.07);
      z-index: 1050;

      &.open {
        display: flex;
      }

      a {
        margin: 10px 0;
        font-size: 1.2rem;
      }
    }
  }

  @media (max-width: 900px) {
    .menu-toggle {
      display: flex;
    }
    nav {
      display: none;
    }
    nav.open {
      display: flex;
    }
  }
}



</style>